export default __webpack_public_path__ + "static/media/Pehia.30f1c4ad.jpg";